<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>

    <ion-title>{{currentCommunityName}}</ion-title>
    <ion-buttons *ngIf="profile != null" slot="end">
      <ion-item lines="none">
        <ion-select [ngModel]="currCommunityId" (ionChange)="selectCommunity($event)" interface="popover">
          <ion-select-option [value]="0">-- Select Community --</ion-select-option>
          <ion-select-option *ngFor="let community of myCommunities" [value]="community.communityId">
            {{community.name}}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-button (click)="showProfilePopover($event)">
        {{profile.username}}
        <ion-icon name="exit-outline" slot="end"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="alert" *ngIf="currentSub?.isExpired && hideExpired === false && currentCommunity !== null">
    <p>
      Your Subscription Has Expired! Your platform fee has increased to {{currentCommunity?.transactionFee}}%.
      Resubscribe to keep your benefits!
    </p>
    <div class="buttons">
      <ion-button routerLink="/community/subscription" routerDirection="forward">Resubscribe</ion-button>
      <ion-button color="secondary" (click)="dismissExpired()">Hide</ion-button>
    </div>
  </div>
  <div class="alert" *ngIf="currentSub?.owedAmount > 0 && currentCommunity !== null">
    <p>
      You currently have an outstanding balance of {{currentSub.owedAmount | currency: 'USD' : 'symbol-narrow' :
      '1.2-2'}}.
      Pay now
    </p>
    <div class="buttons">
      <ion-button routerLink="/community/billing" routerDirection="forward">Pay Now</ion-button>
    </div>
  </div>
  <div class="notification" *ngIf="showNotification">
    <div class="flex-c-c flex-gap">
      <p class="b">
        <span class="large-font">Suite Update: All New Onboarding Form, News Notifications, and More!</span><br />
        Click <a rel="noopener" href="https://outlook.office365.com/book/CommuniBeeSuiteDemo@launch57.com"
          target="_blank">HERE</a> to book a demo OR click <a rel="noopener"
          href="https://communibee.ca/manage-content-onboard-users-and-promote-news/"
          target="_blank">HERE</a> to learn more!
      </p>
      <div class="buttons">
        <ion-button fill="clear" class="font15em" (click)="dismissNotification()"><ion-icon
            name="close-circle-outline"></ion-icon></ion-button>
      </div>
    </div>
  </div>
</ion-header>